// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1)
// Режим вида ячеек «Statuses and zones» (status_zones; прежний status_pie — алиас). Перенос логики src/utils/cellPie.js в регистр режимов:
// спутники ячейки-даты (§1.2 плана p149): zone_val = { зона: { мера: сумма } } — строки запаса (зоны уровня запаса get_grade бэка);
// st_val = { статус: { мера: сумма } } — статусы документов (как cellPie: остаток «No document» = значение ячейки − Σ статусов); у непокрытого ключи
// backlog / loss (группировка по reason). Есть zone_val с мерой ячейки — слои по зонам, иначе — по st_val. Цвета статусов — cellPie_color, зон — CELL_ZONE_COLORS
import { t as tI18n } from '@/i18n'
import { cellPie_sectors, cellPie_color } from '@/utils/cellPie'
import { STOCK_ZONES, STOCK_ZONE_ORDER, stockZones_on, stockZone_title } from '@/utils/stockZones'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p207 зони запасу в колах — палітра і межі як у графіка покриття форми комірки)

export const STATUS_ZONES_VIEW = 'status_zones'

// зоны уровня запаса (processing_distr.get_grade) и причины непокрытого
export const CELL_ZONE_COLORS = {
    oos: '#e53935', min: '#fb8c00', opt: '#c0ca33', ok: '#43a047', max: '#1e88e5', excess: '#0d47a1', no_sales: '#9e9e9e',
    backlog: '#e53935', loss: '#880e4f',
}
// IE 2026 11 01 / ODOO-350449 (заказ Игоря: статуси-крапка, зони запасів, виконання планів — T12): названия зон остатка — свои ключи
// (uk: Аутсток / Мінімальний / Оптимальний / Нормативний / Максимальний / Понаднормовий / Без продажів), общие «OK» / «Excess» / «No sales» не трогаем
export const ZONE_TITLES = {
    oos: 'Stockout', min: 'Minimum', opt: 'Optimal', ok: 'Normative', max: 'Maximum', excess: 'Over-normative', no_sales: 'Without sales',
    backlog: 'Backlog', loss: 'Lost sales',
}
export const ZONE_ORDER = ['oos', 'min', 'opt', 'ok', 'max', 'excess', 'no_sales']   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: статуси-крапка, зони запасів, виконання планів — T12): export для тестов

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }
const isObj = (o) => !!o && typeof o === 'object' && !Array.isArray(o)
const zoneKey = (z) => str(z).replace(/^(stock|zone|grade)-/i, '').toLowerCase().replace(/-/g, '_')

// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p207 зони запасу в колах — палітра і межі як у графіка покриття форми комірки): при fe.ux.stockZonesChartPalette (дефолт ВКЛ) цвета, порядок и названия зон запаса — из utils/stockZones.js (общие с полосами графика
// «Покриття, міс» формы ячейки: oos красная · min рыжая «Критичний» · opt жёлтая «Зона поповнення» · ok белая «Оптимальний» · max зелёная · excess тёмно-зелёная);
// причины непокрытого (backlog / loss) — прежние цвета. ВЫКЛ — прежние CELL_ZONE_COLORS / ZONE_TITLES / ZONE_ORDER
export function statusZones_colors() {
    if (!stockZones_on()) return CELL_ZONE_COLORS
    const out = { ...CELL_ZONE_COLORS }
    for (const k of STOCK_ZONE_ORDER) out[k] = STOCK_ZONES[k].color
    return out
}
export function statusZones_order() { return stockZones_on() ? STOCK_ZONE_ORDER : ZONE_ORDER }
export function statusZones_title(key, t) {
    const k = zoneKey(key) === 'dead' ? 'no_sales' : zoneKey(key)
    if (stockZones_on() && STOCK_ZONES[k]) return stockZone_title(k, t)
    const tt = typeof t === 'function' ? t : (x) => x
    return ZONE_TITLES[k] ? tt(ZONE_TITLES[k]) : ''
}

export function statusZones_color(key) {
    const z = zoneKey(key)
    return statusZones_colors()[z] || cellPie_color(key)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p207 зони запасу в колах — палітра і межі як у графіка покриття форми комірки)
}

// слои зон: zoneVal — спутник zone_val, measure — мера ячейки → [{ key, title, value, color, tone }] в порядке шкалы зон (прочие — после, по убыванию) | null
export function statusZones_zoneLayers(zoneVal, measure, t = tI18n) {
    if (!isObj(zoneVal)) return null
    const ms = str(measure)
    if (!ms) return null
    const tt = typeof t === 'function' ? t : (x) => x
    const list = []
    for (const z of Object.keys(zoneVal)) {
        const byM = zoneVal[z]
        if (!isObj(byM) || !Object.prototype.hasOwnProperty.call(byM, ms)) continue
        const v = num(byM[ms])
        if (!(v > 0)) continue
        const k = zoneKey(z)
        list.push({ key: z, title: statusZones_title(k, tt) || tt(str(z).charAt(0).toUpperCase() + str(z).slice(1)), value: v, color: statusZones_color(z), tone: 'solid' })   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p207 зони запасу в колах — палітра і межі як у графіка покриття форми комірки)
    }
    if (!list.length) return null
    const order = statusZones_order()   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p207 зони запасу в колах — палітра і межі як у графіка покриття форми комірки)
    const rank = (l) => { const i = order.indexOf(zoneKey(l.key)); return i < 0 ? order.length : i }
    list.sort((a, b) => (rank(a) - rank(b)) || (b.value - a.value))
    return list
}

// слои статусов: st_val как cellPie_sectors (остаток «No document» последним), backlog / loss — цвета причин непокрытого
export function statusZones_statusLayers(stVal, measure, cellValue, t = tI18n, palette) {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: p149 fix2-fe): palette — stats.palette бэка
    const pie = cellPie_sectors(stVal, measure, cellValue, { t, palette })
    if (!pie) return null
    const tt = typeof t === 'function' ? t : (x) => x
    return {
        value: pie.value,
        layers: pie.sectors.map(s => {
            const z = zoneKey(s.key)
            const reason = z === 'backlog' || z === 'loss'
            return { key: s.key, title: reason ? tt(ZONE_TITLES[z]) : s.title, value: s.value, color: reason ? CELL_ZONE_COLORS[z] : s.color, tone: 'solid' }
        }),
    }
}

export default {
    key: STATUS_ZONES_VIEW,
    title: 'Statuses and zones',
    satellites: ['zone_val', 'st_val'],
    needsData: true,
    // ctx: { t, date, measure, cell (= dataItem[date]), value (значение ячейки) }
    layersOf(dataItem, binding, ctx = {}) {
        const cell = ctx.cell
        if (!isObj(cell)) return null
        const t = ctx.t || tI18n
        const zl = statusZones_zoneLayers(cell.zone_val, ctx.measure, t)
        if (zl) return { layers: zl, value: ctx.value, satellite: 'zone_val' }
        const sl = statusZones_statusLayers(cell.st_val, ctx.measure, ctx.value, t, ctx.palette)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: p149 fix2-fe)
        if (sl) return { layers: sl.layers, value: sl.value, satellite: 'st_val' }
        return null
    },
    tipOf(res, ctx = {}) {
        const t = ctx.t || tI18n
        return { caption: t(res && res.satellite === 'zone_val' ? 'By stock zone' : 'By document status') }
    },
}
